<template>
  <div class="container mainContent">
    <h2>Delegate Registration</h2>

    <h3>Prices</h3>
    <table class="table">
      <thead>
        <tr>
          <th></th>
          <th class="text-center">Early bird rates (Ends 28th Feb 2017)</th>
          <th class="text-center">Regular rates (Ends 31st Oct 2017)</th>
          <th class="text-center">Late / On-site registration (From 1st Nov 2017)</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Regular participant</td>
          <td class="text-center">€350</td>
          <td class="text-center">€450</td>
          <td class="text-center">€550</td>
        </tr>
        <tr>
          <td>Low and middle income countries *</td>
          <td class="text-center">€250</td>
          <td class="text-center">€250</td>
          <td class="text-center">€250</td>
        </tr>
        <tr>
          <td>Student *</td>
          <td class="text-center">€190</td>
          <td class="text-center">€190</td>
          <td class="text-center">€190</td>
        </tr>
        <tr>
          <td>One day only *</td>
          <td class="text-center">-</td>
          <td class="text-center">€76</td>
          <td class="text-center">€76</td>
        </tr>
        <tr>
          <td>Accompanying person *</td>
          <td class="text-center">€63</td>
          <td class="text-center">€63</td>
          <td class="text-center">€63</td>
        </tr>
      </tbody>
    </table>

    <p>
      All payment are to be made in Pound sterling (GBP).
    </p>
    <ul>
      <li>
        The Euro (EUR) prices are provided as guides and will vary with exchange rates on the day of payment.
      </li>
      <li>
        The dates are based on the UK, GMT timezone.
      </li>
      <li>
        Low-income and middle income economies, as determined by the World Bank.
      </li>
      <li>
        Student identification must be produced onsite at registration to validate student status.
      </li>
      <li>
        One day only registration allows access for any single day of your choice.
      </li>
      <li>
        Accompanying person registration includes Opening and Closing ceremonies and the Welcome reception but no other sessions. Only one accompanying person per registered delegate.
      </li>
    </ul>

    <h3>Insurance</h3>
    <p>Please note that AIDSImpact cannot be held responsible for any loss, damages or claims that delegates may incur. We advise that all delegates take their own travel and health insurance before travelling to the conference. </p>

    <h3>Cancellation policy:</h3>
    <p>
      Please note that the conference office should be notified of cancellations by e-mail (secretariat@AIDSImpact.com) . Due to financial obligations incurred, 50% of the paid conference fee will be refunded if the conference office receives your written cancellation by email before 1st August 2017. We regret that no refunds can be made for any cancellation received after 2nd August 2017. 
    </p>
    <p>
      If you cannot attend the conference, you may transfer your registration to another member of your organization at any time. Notification of transfer must be given in writing to the conference office (secretariat@AIDSImpact.com) prior to the conference. 
    </p>
    <p>
      'No shows' (due to all causes including natural disasters) are non-refundable and are liable for the full registration fee. 
    </p>

    <hr>
    <p>
      <em>
        Card payment facility issues - Contact details:<br />
        Postal address: AIDSImpact Conference, Nieuwe Achtergracht 100, 1018 WT Amsterdam<br />
        Phone number: 08444849447<br />
        Email address (Card payment issues only): <a href="mailto:WPPCS5@aidsimpact.net" v-if="true">WPPCS5@aidsimpact.net</a>
      </em>
    </p>
  </div>
</template>

<script>
export default {
  name: "info_delegateregistration"
}
</script>



/** WEBPACK FOOTER **
 ** info_delegateregistration.vue?0e166014
 **/